var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_589",
    x: 0,
    y: 0,
    width: 132,
    height: 132,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_167016",
    x: 14.768,
    y: 10.755,
    width: 85.39,
    height: 79.435,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_584",
    x: 36.362,
    y: 33.68,
    width: 41.798,
    height: 41.798,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "wrench",
    x: 42.235,
    y: 43.49,
    width: 72.526,
    height: 72.241,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Setup_Icon",
    "data-name": "Setup Icon",
    transform: "translate(-71 -369.988)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 71, 369.99)",
    filter: "url(#Ellipse_589)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_589-2",
    "data-name": "Ellipse 589",
    transform: "translate(9 6)",
    fill: "#00a9e0",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 57,
    r: 57,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 57,
    r: 56,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Settings",
    transform: "translate(96.768 388.742)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2610",
    "data-name": "Group 2610",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -25.77, -18.76)",
    filter: "url(#Path_167016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_167016-2",
    "data-name": "Path 167016",
    d: "M63.857,42.6a27.113,27.113,0,0,0,0-9.581l5.873-5.939L63.168,15.729l-8.1,2.133a25.309,25.309,0,0,0-8.268-4.79L44.6,5H31.473l-2.2,8.071a25.308,25.308,0,0,0-8.268,4.79l-8.1-2.133L6.34,27.082l5.873,5.9v.036a27.113,27.113,0,0,0,0,9.581v.036L6.34,48.54,12.9,59.892l8.1-2.133a25.309,25.309,0,0,0,8.268,4.79",
    transform: "translate(19.43 13.76)",
    fill: "#00a9e0",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -25.77, -18.76)",
    filter: "url(#Ellipse_584)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_584-2",
    "data-name": "Ellipse 584",
    cx: 9.899,
    cy: 9.899,
    r: 9.899,
    transform: "translate(47.36 41.68)",
    fill: "#00a9e0",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 4
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 71, 369.99)",
    filter: "url(#wrench)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "wrench-2",
    "data-name": "wrench",
    d: "M50.845,42.367a1.95,1.95,0,0,1,.657,1.588,2.031,2.031,0,0,1-.876,1.7L45.258,51.02a2.356,2.356,0,0,1-1.7.767,2.021,2.021,0,0,1-1.588-.767L20.717,29.767a14.3,14.3,0,0,1-8.492.711A15.116,15.116,0,0,1,4.5,26.261,15.736,15.736,0,0,1,.229,17.99,13.819,13.819,0,0,1,1.544,8.951l10.3,10.08,7.012-7.012L8.775,1.939A14.718,14.718,0,0,1,17.758.789a15.439,15.439,0,0,1,8.326,4.217A15.11,15.11,0,0,1,30.3,12.73a13.906,13.906,0,0,1-.711,8.382Z",
    transform: "translate(52.76 50.44)",
    fill: "#00a9e0",
    stroke: "#fff",
    strokeWidth: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetupIcon);
export default __webpack_public_path__ + "static/media/setup-icon.8e31a6eeff03361c1e399c684f117156.svg";
export { ForwardRef as ReactComponent };